const path = {
    HOME: '/*',
    HOME_PAGE: '',
    LOGIN: '/login',
    CONTACT: 'lien-he-tu-van',
    NEWS: 'tin-tuc',
    CENTER_EDUCATION:'trung-tam-dao-tao',
    PROGRAM_EDUCATION:'chuong-trinh-dao-tao',
    INFORMATION:'gioi-thieu',
    RECRUITMENT:'dang-ki-tuyen-dung',
    DETAIL_NEW:'tin-tuc/chi-tiet/:id',
    ENGLISHCOMMUNICATION:'/course/com/english-communication',
    COURSE_NAME:'course/:name',
    STAR:'*',
    
    // Admin
    HOME_ADMIN:'/he-thong/admin',
    NEWSPOST:'',
    ATTRACTIVE:'maneger/tao-uu-dai-hap-dan',
    CLASS_STUDENTS:'maneger/tao-lop-hoc-lich-hoc',
    CONTACT_INFOR:'maneger/lien-he-tu-van',
    RECRUITMENT_PAGE:'maneger/tuyen-dung',
    LIST_CONSOLTED:'maneger/danh-sach-da-tu-van',
    VIDEO_EXAM:'maneger/video-du-thi'
}

export default path;